import axios from 'axios';
import { getUrlApiNucardapio } from '../_environments/ConfigAPI'

export default async function axiosGet(url) {
    var ret = ""; 
    var urlApi = await getUrlApiNucardapio();
    var retorno = await axios.get(urlApi + url)
    return retorno.data;
}